export default function formatErrors(err) {
    return Object.keys(err.errors).reduce( (acc, key) => {
        return {
            ...acc, 
            [key]: err.errors[key][0]
        }
    }, {});
}